import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../theme';

/**
 * One heading treatment for every section: a green eyebrow over a large light
 * title. Alignment and tone are the only things that vary -- the page had four
 * different heading styles before this existed.
 */
const SectionHeading = ({
    eyebrow,
    title,
    align = 'left',
    tone = 'dark',
    component = 'h2',
    maxWidth,
    sx,
}) => (
    <Box
        sx={{
            textAlign: align,
            maxWidth,
            mx: align === 'center' ? 'auto' : undefined,
            ...sx,
        }}
    >
        {eyebrow && (
            <Typography
                variant="overline"
                sx={{
                    display: 'block',
                    color: tone === 'light' ? colors.green : colors.greenText,
                    letterSpacing: '0.18em',
                    fontWeight: 600,
                    fontSize: '0.75rem',
                    lineHeight: 1.6,
                }}
            >
                {eyebrow}
            </Typography>
        )}
        {title && (
            <Typography
                component={component}
                sx={{
                    fontWeight: 300,
                    fontSize: 'clamp(1.9rem, 4vw, 2.9rem)',
                    lineHeight: 1.2,
                    textWrap: 'balance',
                    mt: eyebrow ? 1.5 : 0,
                    color: tone === 'light' ? '#fff' : '#111',
                }}
            >
                {title}
            </Typography>
        )}
    </Box>
);

export default SectionHeading;
